export default {
    'USER_DATA': 'USER_DATA',
}